import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import type { TradePendingProps } from './trade.pending.connect';

export const TradePendingComponent: FC<TradePendingProps> = ({ addonAction }) => {
  return (
    <div className="w-100 alert alert-discreet-warning d-flex mb-0 px-0" data-e2e="trade-pending">
      <div className="card-body">
        <div className="display-5 align-middle">
          <FormattedMessage id="form.status.tradePending" />
        </div>
        {addonAction === 'Increase' && (
          <div className="display-3 align-middle" data-e2e="you-buy">
            <FormattedMessage id="form.status.youBuy" />
          </div>
        )}
        {addonAction === 'Decrease' && (
          <div className="display-3 align-middle" data-e2e="you-sell">
            <FormattedMessage id="form.status.youSell" />
          </div>
        )}
      </div>
    </div>
  );
};

TradePendingComponent.displayName = 'TradePendingComponent';
